/** First year `getHolidays` can compute, and therefore the first year the business-day utils accept. */
export const HOLIDAYS_MIN_YEAR = 1900;

/** Last year `getHolidays` can compute, and therefore the last year the business-day utils accept. */
export const HOLIDAYS_MAX_YEAR = 2099;
